"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformPayoutStatusToString = transformPayoutStatusToString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const utils_1 = require("@daytrip/utils");
const transformDateTimeToString_1 = require("./transformDateTimeToString");
function transformPayoutStatusToString(payoutStatus, payout, displayStatusDate) {
    let dateString = "";
    if ((0, utils_1.isNotUndefinedOrNull)(payout) && displayStatusDate === true) {
        switch (payout.status) {
            case legacy_enums_1.PayoutStatus.Pending:
                dateString = ` - ${(0, transformDateTimeToString_1.transformDateTimeToString)(payout.createdAt)}`;
                break;
            case legacy_enums_1.PayoutStatus.Fulfilled:
                dateString = ` - ${(0, transformDateTimeToString_1.transformDateTimeToString)(payout.fulfilledAt)}`;
                break;
            case legacy_enums_1.PayoutStatus.Failed:
                dateString = ` - ${(0, transformDateTimeToString_1.transformDateTimeToString)(payout.failedAt)}`;
                break;
            case legacy_enums_1.PayoutStatus.Unknown:
                dateString = ` - ${(0, transformDateTimeToString_1.transformDateTimeToString)(payout.unknownAt)}`;
                break;
            case legacy_enums_1.PayoutStatus.Approved:
                dateString = ` - ${(0, transformDateTimeToString_1.transformDateTimeToString)(payout.approvedAt)}`;
                break;
            case legacy_enums_1.PayoutStatus.Declined:
                dateString = ` - ${(0, transformDateTimeToString_1.transformDateTimeToString)(payout.declinedAt)}`;
                break;
            case legacy_enums_1.PayoutStatus.Processing:
                dateString = ` - ${(0, transformDateTimeToString_1.transformDateTimeToString)(payout.processingAt)}`;
                break;
        }
    }
    switch (payoutStatus) {
        case legacy_enums_1.PayoutStatus.Pending:
            return `pending${dateString}`;
        case legacy_enums_1.PayoutStatus.Fulfilled:
            return `fulfilled${dateString}`;
        case legacy_enums_1.PayoutStatus.Failed:
            return `failed${dateString}`;
        case legacy_enums_1.PayoutStatus.Unknown:
            return `unknown${dateString}`;
        case legacy_enums_1.PayoutStatus.Approved:
            return `approved${dateString}`;
        case legacy_enums_1.PayoutStatus.Declined:
            return `declined${dateString}`;
        case legacy_enums_1.PayoutStatus.Processing:
            return `processing${dateString}`;
        default:
            return "unknown status";
    }
}
//# sourceMappingURL=transformPayoutStatusToString.js.map